/**
 * @generated SignedSource<<8123d4d752ec36317e81af577d546915>>
 * @relayHash 81e92b7bef30c91df7d1d5fc36cdd372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type LivePagesByLineWithContributorsComponentEditorContentStateQuery$variables = {
  contentId: string;
  isDraft: boolean;
};
export type LivePagesByLineWithContributorsComponentEditorContentStateQuery$data = {
  readonly availableContentStates: {
    readonly customContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
    } | null> | null;
    readonly spaceContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null> | null;
  } | null;
  readonly singleContent: {
    readonly contentState: {
      readonly color: string;
      readonly id: string | null;
      readonly isCallerPermitted: boolean | null;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null;
    readonly contentStateLastUpdated?: {
      readonly value: string;
    } | null;
    readonly id: string | null;
  } | null;
};
export type LivePagesByLineWithContributorsComponentEditorContentStateQuery = {
  response: LivePagesByLineWithContributorsComponentEditorContentStateQuery$data;
  variables: LivePagesByLineWithContributorsComponentEditorContentStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isDraft"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "color"
},
v4 = {
  "kind": "ScalarField",
  "name": "restrictionLevel"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
          }
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isCallerPermitted"
          }
        ]
      },
      {
        "condition": "isDraft",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "format",
                "value": "USER_FRIENDLY"
              }
            ],
            "concreteType": "ConfluenceDate",
            "kind": "LinkedField",
            "name": "contentStateLastUpdated",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ],
            "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "AvailableContentStates",
    "kind": "LinkedField",
    "name": "availableContentStates",
    "plural": false,
    "selections": [
      {
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "customContentStates",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "spaceContentStates",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v1/*: any*/),
          (v4/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "81e92b7bef30c91df7d1d5fc36cdd372",
    "id": "8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72",
    "metadata": {},
    "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
    "operationKind": "query",
    "text": "query LivePagesByLineWithContributorsComponentEditorContentStateQuery($contentId:ID!,$isDraft:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
  }
};
})();

(node as any).hash = "cbad882df31b75e4699e60f1bcf2ae8b";

export default node;
